// src/index.js
import React from "react";
import "./index.css"; // Global styles
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const { pathname, search, hash } = window.location;
if (pathname !== "/" && pathname !== "/index.html") {
  // If we have a hash, it's likely the correct router path, so we drop the pathname.
  // If no hash, we assume the pathname was the intended route.
  const target = hash ? "/" + hash : "/#" + pathname + search;
  window.location.replace(target);
}

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById("root")
);

serviceWorker.unregister();
